<template>
  <section id="about" class="n2-seccion" v-if="PN?.Mostrar">
    <div class="n2-contenedor n2-dos-columnas" :class="{ 'n2-dos-columnas--invertida': PN.ImageLeft === false }">
      <figure v-if="PN.Imagen" class="n2-foto n2-aparece">
        <img :src="imagenIDtoSRC(PN.Imagen)" :alt="'Fotografía de ' + NOTARIA.Nombre + ' - Notario'" loading="lazy" />
      </figure>
      <div class="n2-aparece">
        <h2 class="n2-titulo-seccion" v-html="PN.Titulo?.Texto"></h2>
        <div v-if="PN.Descripcion?.Texto" class="n2-texto-rico" :style="alineacionTexto(PN.Descripcion.css)" v-html="PN.Descripcion.Texto"></div>
        <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowNotarios && NOTARIA.Notarios?.length" :to="getLocalePath('/notarios')" class="n2-enlace">
          {{ tituloSeccion(NOTARIA, 'Notario', $t) }} <span aria-hidden="true">→</span>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
// Panel: Inicio → Palabras del notario
const PN = computed(() => NOTARIA.value?.Theme?.Home?.PN)
</script>
